angular.module('impactx.autocompletegroup', []).config([function () {}]);